import { Route, Routes } from 'react-router-dom';
import Header from './components/Header/Header';
import './main.css';
import AddTaskPage from './pages/AddTaskPage';
import EditTask from './pages/EditTask';
import Homepage from './pages/Homepage';

function App() {
  return (
    <>
      <Header/>
      <Routes>
        <Route path='/' element={<Homepage/>} />
        <Route path='/add-task' element={<AddTaskPage/>} />
        <Route path='/edit-task/:taskId' element={<EditTask/>} />
      </Routes>
    </>
  );
}

export default App;
